import { extractRefCode } from "@/entities/invitation"
import { useLaunchParams } from "@/shared/lib/telegram"

export function useInviteRefCode(): string | null {
	const lp = useLaunchParams()
	return extractRefCode(lp.tgWebAppStartParam)
}
